import React from 'react';

import RichTextEditorDebugger from '../../RichTextEditor/components/RichTextEditorDebugger';

import styles from './EventDescription.module.scss';

const EventDescriptionDebugger = ({ state }) => {
  return (
    <RichTextEditorDebugger
      state={state}
      editableContentId={styles.mainSection}
      stateDisplayClassName={styles.stateDisplay}
    />
  );
};

export default EventDescriptionDebugger;
